import { render, staticRenderFns } from "./WishlistHeart.vue?vue&type=template&id=e5810e1a&scoped=true"
import script from "./WishlistHeart.vue?vue&type=script&lang=js"
export * from "./WishlistHeart.vue?vue&type=script&lang=js"
import style0 from "./WishlistHeart.vue?vue&type=style&index=0&id=e5810e1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5810e1a",
  null
  
)

export default component.exports